<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="addRefundNumberModal" persistent max-width="530px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('addRefundNumber.title') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeAddRefundNumberModal(), $validator.reset()" class="close"
                  ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn
                >
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert type="success" :value="successAlert">
                {{ $t('addRefundNumber.addedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm7 md7>
                    <v-text-field
                      style="width: 70%"
                      :label="$t('columns.refundNumber') + '*'"
                      v-model="addRefundNumberData.refund_number"
                      :error-messages="errors.collect('Refund Number')"
                      v-validate="'required'"
                      data-vv-name="Refund Number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddRefundNumberModal(), $validator.reset()"
                outline
                color="normal"
                >{{ $t('common.cancel') }}</v-btn
              >
              <v-btn type="submit" style="height:auto" class="rtl-mr-4pct" outline color="success"
                >{{ $t('common.add') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'addRefundNumberData',
    'closeAddRefundNumberModal',
    'addRefundNumberModal',
    'successAlert',
    'addRefundNumber'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addRefundNumber()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addRefundNumber.vue